import { useState } from "react";
import { useForm } from "react-hook-form";
import { useFirebase, isLoaded } from "react-redux-firebase";
import { useSelector } from "react-redux";

import Loading from '../components/Loading';
import UserForm from '../components/UserForm';
import Page from './Page';

const ChangePasswordForm = ({onSave}) => {
  const { register, handleSubmit, getValues, errors } = useForm();

  return (
    <form onSubmit={handleSubmit(onSave)}>
      <div class="form-group">
        <label for="">New password*</label>
        <input type="password" class="form-control" name="password" ref={register({minLength: 6})} />
      </div>
      <div class="form-group">
        <label for="">Confirm password*</label>
        <input
          type="password"
          class="form-control"
          name="passwordConfirmation"
          ref={
            register({
              validate: {
                passwordMatch: value => value === getValues().password
              }}
            )}
        />
      </div>
      { errors.password && (
        <div className="alert alert-warning mt-3" role="alert">
          Password should be at least 6 characters long
        </div>
      )}
      { errors.passwordConfirmation && (
        <div className="alert alert-warning mt-3" role="alert">
          Passwords don't match
        </div>
      )}
      <div class="form-group">
        <input class="btn btn-primary float-right" type="submit" value="Change password" />
      </div>
    </form>
  )

}

const UserEdit = () => {
  const profile = useSelector(state => state.firebase.profile)
  const firebase = useFirebase();
  const [ isSuccessAccount, setIsSuccessAccount ] = useState(false);
  const [ isSuccessPassword, setIsSuccessPassword ] = useState(false);
  const [ isSubmitting, setIsSubmitting ] = useState(false);

  const onUpdateAccount = async (formData) => {
    setIsSubmitting(true);

    // remove all "undefined" fields
    Object.keys(formData).forEach(key => formData[key] === undefined ? delete formData[key] : {});

    try {
      await firebase.updateProfile(formData);
      setIsSuccessAccount(true);
    } catch (e) {
      console.error(e);
    }

    setIsSubmitting(false);
  }

  const onUpdatePassword = async ({password}) => {
    setIsSubmitting(true);

    try {
      await firebase.auth().currentUser.updatePassword(password);
      setIsSuccessPassword(true);
    } catch (e) {
      console.error(e);
    }

    setIsSubmitting(false);
  }

  if (isSubmitting || !isLoaded(profile)) {
    return <Loading />
  }

  return (
    <Page title="Account" action={<></>}>
      <div className="row">
        <div className="col-12">
          { isSuccessAccount && (
            <div className="alert alert-success" role="alert">
              Updated account successfully
            </div>
          )}
          { isSuccessPassword && (
            <div className="alert alert-success" role="alert">
              Updated password successfully
            </div>
          )}
          <div className="card mb-3">
            <h2 class="h5 mb-3">Details</h2>
            <UserForm user={profile} onSave={onUpdateAccount} />
          </div>
          <div className="card">
            <h2 class="h5 mb-3">Change password</h2>
            <ChangePasswordForm onSave={onUpdatePassword} />
          </div>
        </div>
      </div>
    </Page>
  )
}

export default UserEdit;
